const BASE = '/assets/templates/onelive-basic/ftv';

export const oneliveAssets = {
  rank: `${BASE}/ico_rank.svg`,
  notice: `${BASE}/ico_notice.svg`,
  vod: `${BASE}/ico_vod.svg`,
  chat: `${BASE}/chat_board_off.svg`,
  gift: `${BASE}/gift_shop_ico.svg`,
  event: `${BASE}/event.svg`,
  movie: `${BASE}/movie.svg`,
  movieOn: `${BASE}/movie_on.svg`,
  moreOn: `${BASE}/more_on.svg`,
  moreOff: `${BASE}/more_off.svg`,
  arrowLeftWhite: `${BASE}/left_arrow_white.svg`,
  arrowRightWhite: `${BASE}/right_arrow_white.svg`,
  arrowLeftBlack: `${BASE}/left_arrow_black.svg`,
  arrowRightBlack: `${BASE}/right_arrow_black.svg`,
  sideMenu: `${BASE}/side_menu_off.svg`,
  sideMenuOn: `${BASE}/side_menu_on.svg`,
  menuMobile: `${BASE}/menu_mobile.svg`,
  search: `${BASE}/ico_search.svg`,
  searchWhite: `${BASE}/ico_search_white.svg`,
  itemSection: `${BASE}/item-s.png`,
  shopBuy: `${BASE}/gift_shop_on.svg`,
  coinCharge: `${BASE}/charger_on.svg`,
  alertCheck: `${BASE}/ico_support.svg`,
  orderItem: `${BASE}/mian-item.png`,
  orderCoin: `${BASE}/ico-money.png`,
  orderBank: `${BASE}/gift_shop_on.svg`,
  guestAvatar: `${BASE}/mb.png`,
  footerCert: `${BASE}/footer_img.png`,
  hallOfFame: `${BASE}/hall-of-fame.svg`,
  levelDefault: `${BASE}/hall-of-fame.svg`,
  support: `${BASE}/ico_support.svg`,
  arrowUp: `${BASE}/ico_arrow_up.svg`,
  navHome: `${BASE}/mian-home.png`,
  navItem: `${BASE}/mian-item.png`,
  navLive: `${BASE}/mian-live.png`,
  navUser: `${BASE}/main-user.png`,
  drawerMypage: `${BASE}/main-user.png`,
  drawerItem: `${BASE}/mian-item.png`,
  drawerMessage: `${BASE}/ico-message.png`,
  drawerCoin: `${BASE}/ico-money.png`,
};
